import styled from 'styled-components';

export const Card = styled.div`
  box-shadow: rgba(43, 18, 2, 0.06) 0px 0px 5px 3px;
`;
